import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input, Select, Spin } from "antd";
import PropTypes from "prop-types";
import { debounce } from "lodash";
// import { DatePicker, useJalaliLocaleListener } from "antd-jalali";
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { Modals, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";
import moment from 'moment-jalaali';
// moment.loadPersian({ usePersianDigits: false });

import { CalendarOutlined, DeleteOutlined } from '@ant-design/icons';

const Component = ({ data = {}, onUpdate, options = [] }) => {

	const initialState = { categories: options, editTime: false  };
	const [state, setState] = useState(initialState);
	const { loading, submitting, visible, categories } = state;
	const { id } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();
    const [editTime, setEditTime] = useState(false);

// --- مدیریت حالت ویرایش ---

	const handleSearch = debounce((search) => {
		if (search?.length > 1) {
			API.category
				.list({ paginate: false, search })
				.then(({ data }) => {
					setState((prevState) => ({
						...prevState,
						categories: data.map((o) => ({
							value: o.id,
							label: `${o.title}`,
						})),
					}));
				})
				.catch(() => {});
		}
	}, 500);

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));
				console.log("values : ", values)

				values.general = true;

				if (!values.categories) {
					delete values.categories;
					values.general = true;
				}
				if (values.categories?.length > 0) {
					values.general = false;
					values.categories = values.categories.map((value) => value);
				}

				if (values.expireAt) {
					let expireAt = values.expireAt.year+"-"+values.expireAt.month+"-"+values.expireAt.day
					values.expireAt = moment(expireAt, 'jYYYY-jM-jD').format("YYYY-MM-DD")
				}

				const action =
					hash === `#${Modals.CREATE}`
						? API.notification.create(values)
						: API.notification.update(id, values);

				action
					.then(() => {
						onUpdate(null, true);
						navigate(-1);
					})
					.catch(() => {
						setState((prevState) => ({ ...prevState, submitting: false }));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (id) {
					setState((prevState) => ({
						...prevState,
						visible: true,
						loading: true,
					}));

					API.notification
						.details(id)
						.then(({ data }) => {	
							let expireAt = "";
							if (data.expireAt){
								expireAt = moment(data.expireAt).format(
									process.env.REACT_APP_DATE_TIME_FORMAT_JALALI
								)
								let expireAtArr = expireAt.split(" ")
								let expireAtArr1 = expireAtArr[0].split("-")
								expireAt =  {day: parseInt(expireAtArr1[2]), month: parseInt(expireAtArr1[1]), year: parseInt(expireAtArr1[0])}
							}

							form.setFieldsValue({
								...data,
								categories: data?.categories?.map(({ id, title }) => (id)),
								expireAt: expireAt
								// expireAt:
								// 	data.expireAt &&
								// 	moment(data.expireAt).format(
								// 		process.env.REACT_APP_DATE_FORMAT_JALALI
								// 	),
							});
							console.log("form" , form)

							setState((prevState) => ({
								...prevState,
								loading: false,
								categories: data.categories.map(({ id, title }) => ({
									value: id,
									label: title || "-",
								})),
							}));
						})
						.catch(() => {
							setState((prevState) => ({ ...prevState, loading: false }));
						});
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	const handleExpireAt = (date, obj) => {
		const state = {};
		state[obj] = date;
		form.setFieldsValue({
			expireAt: date
		});
	}

	useEffect(componentDidUpdate, [hash]);
		// useJalaliLocaleListener();

	const DatePickerInput = ({ ref }, name) => {
		const date = form ? form.getFieldValue(name) : null;
		return <Input value={date ? `${date.year}-${date.month}-${date.day}` : date} prefix={<CalendarOutlined />} placeholder={Resources.choose} ref={ref} readOnly />;
	};
	return (
		<Drawer
			className="sp-form-drawer"
			placement={process.env.REACT_APP_IS_RTL ? "left" : "right"}
			footer={
				<>
					<Button
						type="primary"
						onClick={handleSubmit}
						loading={submitting}
					>
						{Resources.confirm}
					</Button>
					<Button
						onClick={() => navigate(-1)}
						disabled={submitting}
					>
						{Resources.cancel}
					</Button>
				</>
			}
			onClose={() => navigate(-1)}
			title={`${
				hash === `#${Modals.CREATE}` ? Resources.add : Resources.edit
			} ${Resources.notification}`}
			maskClosable={false}
			open={visible}
			width={768}
		>
			<Form
				layout="vertical"
				form={form}
			>
				{loading ? (
					<Spin className="sp-center-spin" />
				) : (
					<>
						<Form.Item
							name="title"
							label={Resources.title}
							rules={Rules.required}
						>
							<Input />
						</Form.Item>
						<Form.Item
							name="body"
							label={Resources.text}
							rules={Rules.required}
						>
							<Input.TextArea rows={4} />
						</Form.Item>
						<Form.Item
							name="informType"
							label={`${Resources.type} ${Resources.notification}`}
							rules={Rules.required}
						>
							<Select
								options={[
									{ value: Types.notifications.info, label: Resources.info },
									{
										value: Types.notifications.success,
										label: Resources.successfully,
									},
									{
										value: Types.notifications.warning,
										label: Resources.warning,
									},
									{ value: Types.notifications.error, label: Resources.error },
								]}
							/>
						</Form.Item>



	<Form.Item 
						name="expireAt"
						label={`${Resources.date} ${Resources.expire}`}
						// rules={Rules.required}
						>
						<DatePicker
							style={{width:"100%"}}
							locale="fa"
							onChange={value => handleExpireAt(value, 'expireAt')}
							renderInput={(ref) => DatePickerInput(ref, 'expireAt')}
							shouldHighlightWeekends
						/>
					</Form.Item>


						
						<Form.Item
							name="categories"
							label={Resources.category}
						>
							<Select
								options={categories.length > 0 ? categories : options}
								onSearch={handleSearch}
								filterOption={false}
								showArrow={false}
								showSearch
								mode="multiple"
							/>
						</Form.Item>
					</>
				)}
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
};

export default Component;
